import { Col, Divider, Row, Sidepanel, Text } from 'components';
import { useState } from 'react';
import { useSelector } from 'react-redux';

import { Order, Settings } from './components';

const OrderPanel = ({ dataId, setDataId, closeModal }) => {
  const [uploading, setUploading] = useState(false),
    storedData = useSelector((state) => state.admin?.orders?.find((x) => x._id === dataId));

  return (
    <Sidepanel wid={600} pad="0" visible={dataId} closeModal={uploading ? undefined : closeModal}>
      <Col pos="sticky" bg="#fff" zIndex="3" ht="55px" center top="0">
        <Row between center pad="12px 24px 0" noFlex>
          <Text h3 wid="80%" ht="100%">
            {storedData ? `${storedData.owner?.name}'s order` : 'Create new product'}
          </Text>

          <Settings product={storedData} closeModal={() => setDataId(null)} />
        </Row>

        <Divider marg="12px 0 0" />
      </Col>

      <Order order={storedData} closeModal={closeModal} setDataId={setDataId} />
    </Sidepanel>
  );
};

export default OrderPanel;
